import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import API_BASEURL from '@/config';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

/* eslint-disable no-shadow */
const state = {
  token: null,
  apiBaseUrl: API_BASEURL,
  modal: {
    show: false,
    type: null,
  },
  config: {
    date: {
      iso: 'YYYY-MM-DD',
      simple: 'DD MMM YYYY',
    },
  },
  user: {
    name: null,
    role: null,
    email: null,
    id: null,
    privilege: null,
  },
};

function getPrivilagesSlug(data) {
  const privilege = [];
  data.forEach(dt => privilege.push(dt.slug));
  return privilege;
}

const mutations = {
  SET_TOKEN(state, token) {
    state.token = token;
  },
  REMOVE_TOKEN(state) {
    state.token = null;
  },
  SET_MODAL(state, type) {
    state.modal.show = !state.modal.show;
    state.modal.type = type || null;
  },
  SET_USER(state, payload) {
    state.user.name = payload.name;
    state.user.role = payload.role;
    state.user.email = payload.email;
    state.user.id = payload.sub;
    state.user.privilege = payload.privilege ? getPrivilagesSlug(payload.privilege) : [];
  },
  SET_USER_NAME(state, name) {
    state.user.name = name;
  },
  REMOVE_USER(state) {
    state.user.name = null;
    state.user.role = null;
    state.user.email = null;
    state.user.id = null;
    state.user.privilege = null;
  },
};

export default new Vuex.Store({
  state,
  mutations,
  strict: debug,
  plugins: [createPersistedState({
    key: 'ma-activity-backoffice',
  })],
});



// WEBPACK FOOTER //
// ./src/store/index.js